/** Contains type alias and definitions related to Galaxy API models. */
import { GalaxyApi } from "@/api/client";
import {} from "@/api/schema";
export { GalaxyApi };
/**
 * Returns true if the given entry is a top level HDCA and false for sub-collections.
 */
export function isHDCA(entry) {
    return (entry !== undefined && "history_content_type" in entry && entry.history_content_type === "dataset_collection");
}
export function isDCE(item) {
    return item && "element_type" in item;
}
/**
 * Returns true if the given element of a collection is a DatasetCollection.
 */
export function isCollectionElement(element) {
    return element.element_type === "dataset_collection";
}
/**
 * Returns true if the given element of a collection is a Dataset.
 */
export function isDatasetElement(element) {
    return element.element_type === "hda";
}
/**
 * Returns true if the given dataset entry is an instance of DatasetDetails.
 */
export function hasDetails(entry) {
    return "peek" in entry;
}
export function isInaccessible(entry) {
    return "accessible" in entry && !entry.accessible;
}
export function isHistorySummary(history) {
    return !("user_id" in history);
}
export function isHistorySummaryExtended(history) {
    return "contents_active" in history && "user_id" in history;
}
export function isHistoryItem(item) {
    return item && "history_content_type" in item;
}
export function isRegisteredUser(user) {
    return user !== null && "email" in user;
}
export function isAnonymousUser(user) {
    return user !== null && !isRegisteredUser(user);
}
export function isAdminUser(user) {
    return isRegisteredUser(user) && user.is_admin;
}
export function userOwnsHistory(user, history) {
    return (
    // Assuming histories without user_id are owned by the current user
    (isRegisteredUser(user) && !hasOwner(history)) ||
        (isRegisteredUser(user) && hasOwner(history) && user.id === history.user_id) ||
        (isAnonymousUser(user) && hasAnonymousOwner(history)));
}
function hasOwner(history) {
    return "user_id" in history && history.user_id !== null;
}
function hasAnonymousOwner(history) {
    return "user_id" in history && history.user_id === null;
}
export function canMutateHistory(history) {
    return !history.purged && !history.archived;
}
